// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-1T_Wv";
var _4 = "header-_Esyp";
var _5 = "step-2bvCA";
var _6 = "error-1lE30";
var _7 = "controls-3mNkE";
var _8 = "controls__left-3XKD5";
var _9 = "resend-34yLx";
var _a = "resend__label-3xgKZ";
var _b = "success-1iek5";
var _c = "field-hbqYY";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "header", _5 as "step", _6 as "error", _7 as "controls", _8 as "controls__left", _9 as "resend", _a as "resend__label", _b as "success", _c as "field" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "header": _4, "step": _5, "error": _6, "controls": _7, "controls__left": _8, "resend": _9, "resend__label": _a, "success": _b, "field": _c }
